module.exports = __webpack_public_path__ + "img/unstart.5be8c1ec.png";